import { Fragment, useMemo, useState } from "react";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import DataTable from "../../Components/DataTable";
import { createColumnHelper } from "@tanstack/react-table";
import { StatusChip } from "../../Components/common/StatusChip";
import { PageHeader } from "../../Components/common/PageHeader";

const SUPPORT_STATE_META = {
  PENDING: { tone: "neutral", label: "Pendiente" },
  ANSWERED: { tone: "info", label: "Contestado" },
  RESOLVED: { tone: "success", label: "Resuelto" },
  CANCELLED: { tone: "danger", label: "Cancelado" },
};

export const SupportList = () => {
  const { getData } = useDataFetch();

  const { data, isLoading } = getData(
    ["support"],
    "/support/all/dashboard/admin",
    {
      enabled: true,
    }
  );

  const columnHelper = createColumnHelper();

  const columns = useMemo(() => [
    columnHelper.display({
      id: "usuario",
      header: "Usuario",
      cell: props => {
        const row = props.row.original;
        return (
          <div className="d-flex align-items-center gap-2">
            <img
              src={`/users/show/photo/${row.user_id.photo || ""}`}
              alt="usuario"
              height="30"
              width="30"
              style={{ borderRadius: "50%", objectFit: "cover" }}
            />
            <span style={{ fontWeight: 600 }}>{row.user_id.name}</span>
          </div>
        );
      }
    }),
    columnHelper.accessor("issue", {
      header: "Asunto",
    }),
    columnHelper.accessor("topic", {
      header: "Tema",
    }),
    columnHelper.accessor("comment", {
      header: "Comentario",
    }),
    columnHelper.display({
      id: "estado",
      header: "Estado",
      cell: props => {
        const state = props.row.original.state;
        const meta = SUPPORT_STATE_META[state] || { tone: "neutral", label: "Desconocido" };
        return <StatusChip tone={meta.tone}>{meta.label}</StatusChip>;
      }
    }),
  ], [columnHelper]);

  const supports = data?.data?.supports ?? [];

  // `/support/all/dashboard/admin` no pagina en el backend: pagina en
  // cliente sobre lo ya cargado, sin duplicar el fetch.
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const pageData = supports.slice(
    pagination.pageIndex * pagination.pageSize,
    (pagination.pageIndex + 1) * pagination.pageSize
  );

  return (
    <Fragment>
      <PageHeader title="Soporte" crumbs={[{ label: "Soporte" }]} />

      <DataTable
        data={pageData}
        total={supports.length}
        pagination={pagination}
        setPagination={setPagination}
        columns={columns}
        progressPending={isLoading}
        emptyMessage="No hay solicitudes de soporte para mostrar."
      />
    </Fragment>
  );
}
